import { CSSProperties, FC } from 'react';
import { ENodeType } from '@/pages/backend/cardCampSettings/nodeSettings/enum';
import { Collapse } from 'antd';
import styles from './index.less';
import ImageModuleCardTitle from '@/pages/backend/cardCampSettings/recruitPageSettings/ImageModuleCardTitle';
import ExerciseCom from '@/pages/backend/cardCampSettings/nodeSettings/exerciseCom/exerciseCom';
import CertificationCom from './certificationCom';
import VideoCom from './videoCom';
import RichCom from './richCom';

type Props = {
  type: ENodeType;
  name: string;
  className?: string;
  style?: CSSProperties;
  onNameChange: (id: string, name: string) => boolean;
  onChange?: (obj: any) => void;
  onDelete: (id: string) => any;
  id: string;
  defaultValue: any;
  value?: any;
  toggleFullScreen?: (isFullScreen: boolean) => void;
};

const NodeComponent: FC<Props> = ({
  onChange,
  onDelete,
  onNameChange,
  id,
  style,
  className,
  type,
  name,
  value,
  defaultValue,
  toggleFullScreen,
}) => {
  const renderComponentByType = () => {
    let com;
    switch (type) {
      case ENodeType.richtext:
        com = (
          <RichCom
            id={id}
            toggleIsFullScreen={(isFullScreen) => {
              toggleFullScreen?.(isFullScreen);
            }}
            defaultValue={defaultValue?.richText}
            onChange={(content) => {
              console.log('content是', content);
              onChange?.({ richText: JSON.stringify(content) });
            }}
          />
        );
        break;
      case ENodeType.video:
        com = (
          <VideoCom
            toggleIsFullScreen={(isFullScreen) => {
              toggleFullScreen?.(isFullScreen);
            }}
            defaultValue={defaultValue?.video}
            onChange={(videos) => {
              onChange?.({ video: videos });
            }}
          />
        );
        break;
      case ENodeType.exercise:
        com = (
          <ExerciseCom
            toggleIsFullScreen={(isFullScreen) => {
              toggleFullScreen?.(isFullScreen);
            }}
            defaultValue={defaultValue?.exercise}
            onChange={(obj) => {
              onChange?.({ exercises: obj });
            }}
          />
        );
        break;
      case ENodeType.certification:
        com = (
          <CertificationCom
            defaultValue={defaultValue?.professionalCertification}
            onChange={(certId) => {
              onChange?.({ professionalCertification: certId });
            }}
          />
        );
        break;
      default:
        com = <p>节点类型错误</p>;
        break;
    }
    return (
      <Collapse
        className={className}
        defaultActiveKey={['1']}
        style={style}
        items={[
          {
            label: (
              <ImageModuleCardTitle
                maxCount={20}
                onDelete={onDelete}
                deleteModalTitle="确认删除该模块吗？此修改节点保存后才生效"
                deleteModelContent=""
                className={styles.node_component_header}
                showMenuIcon={false}
                onNameChange={onNameChange}
                id={id}
                name={name}
              />
            ),
            key: '1',
            children: com,
          },
        ]}
      />
    );
  };
  return <div className={styles.node_component}>{renderComponentByType()}</div>;
};
export default NodeComponent;
